/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, { enumMixn } from './enumItem';

/**
 * 因子
 */
let EnumDivisor = {
    w00000: new EnumItem('系统', null, 'w00000'),
    w01010: new EnumItem('水温', null, 'w01010'),
    w01001: new EnumItem('pH值', null, 'w01001'),
    w01009: new EnumItem('溶解氧', null, 'w01009'),
    w01003: new EnumItem('浊度', null, 'w01003'),
    w01014: new EnumItem('电导率', null, 'w01014'),
    w01019: new EnumItem('高锰酸盐指数', null, 'w01019'),
    w01018: new EnumItem('化学需氧量（COD）', null, 'w01018'),
    w01017: new EnumItem('五日生化需氧量（BOD5）', null, 'w01017'),
    w21003: new EnumItem('氨氮（NH3-N）', null, 'w21003'),
    w21011: new EnumItem('总磷（以P计）', null, 'w21011'),
    w21001: new EnumItem('总氮（湖、库.以N计）', null, 'w21001'),
    w20122: new EnumItem('铜', null, 'w20122'),
    w20123: new EnumItem('锌', null, 'w20123'),
    w21017: new EnumItem('氟化物（以 F−计）', null, 'w21017'),
    w20128: new EnumItem('硒', null, 'w20128'),
    w20141: new EnumItem('砷', null, 'w20141'),
    w20111: new EnumItem('汞', null, 'w20111'),
    w20115: new EnumItem('镉', null, 'w20115'),
    w20116: new EnumItem('铬', null, 'w20116'),
    w20117: new EnumItem('六价铬', null, 'w20117'),
    w20120: new EnumItem('铅', null, 'w20120'),
    w21016: new EnumItem('氰化物', null, 'w21016'),
    w23002: new EnumItem('挥发酚', null, 'w23002'),
    w22001: new EnumItem('石油类', null, 'w22001'),
    w19002: new EnumItem('阴离子表面活性剂', null, 'w19002'),
    w21019: new EnumItem('硫化物', null, 'w21019'),
    w02003: new EnumItem('粪大肠菌群', null, 'w02003'),
    w21038: new EnumItem('硫酸盐（以S0计）', null, 'w21038'),
    w21022: new EnumItem('氯化物（以C1计）', null, 'w21022'),
    w21007: new EnumItem('硝酸盐（以N计）', null, 'w21007'),
    w20125: new EnumItem('铁', null, 'w20125'),
    w20124: new EnumItem('锰', null, 'w20124'),
    w24004: new EnumItem('三氯甲烷', null, 'w24004'),
    w24005: new EnumItem('四氯化碳（四氯甲烷）', null, 'w24005'),
    w24009: new EnumItem('三溴甲烷', null, 'w24009'),
    w24003: new EnumItem('二氯甲烷', null, 'w24003'),
    w24017: new EnumItem('1，2—二氯乙烷', null, 'w24017'),
    w24024: new EnumItem('环氧氯丙烷', null, 'w24024'),
    w24046: new EnumItem('氯乙烯', null, 'w24046'),
    w24047: new EnumItem('1，1—二氯乙烯', null, 'w24047'),
    w24048: new EnumItem('1，2—二氯乙烯', null, 'w24048'),
    w24049: new EnumItem('三氯乙烯', null, 'w24049'),
    w24050: new EnumItem('四氯乙烯', null, 'w24050'),
    w24062: new EnumItem('氯丁二烯', null, 'w24062'),
    w24064: new EnumItem('六氯丁二烯', null, 'w24064'),
    w25038: new EnumItem('苯乙烯', null, 'w25038'),
    w31001: new EnumItem('甲醛', null, 'w31001'),
    w31002: new EnumItem('乙醛', null, 'w31002'),
    w31004: new EnumItem('丙烯醛', null, 'w31004'),
    w31003: new EnumItem('三氯乙醛', null, 'w31003'),
    w25002: new EnumItem('苯', null, 'w25002'),
    w25003: new EnumItem('甲苯', null, 'w25003'),
    w25004: new EnumItem('乙苯', null, 'w25004'),
    w25005: new EnumItem('二甲苯①', null, 'w25005'),
    w25034: new EnumItem('异丙苯', null, 'w25034'),
    w25010: new EnumItem('氯苯', null, 'w25010'),
    w25011: new EnumItem('1，2—二氯苯', null, 'w25011'),
    w25013: new EnumItem('1，4—二氯苯', null, 'w25013'),
    w25014: new EnumItem('三氯苯②', null, 'w25014'),
    w25016: new EnumItem('四氯苯③', null, 'w25016'),
    w25019: new EnumItem('六氯苯', null, 'w25019'),
    w25023: new EnumItem('硝基苯', null, 'w25023'),
    w25027: new EnumItem('二硝基苯④', null, 'w25027'),
    w25030: new EnumItem('2，4—二硝基甲苯', null, 'w25030'),
    w25032: new EnumItem('2，4，6—三硝基甲苯', null, 'w25032'),
    w25020: new EnumItem('硝基氯苯⑤', null, 'w25020'),
    w25022: new EnumItem('2，4—二硝基氯苯', null, 'w25022'),
    w23020: new EnumItem('2，4—二氯苯酚', null, 'w23020'),
    w23022: new EnumItem('2，4，6—三氯苯酚', null, 'w23022'),
    w23025: new EnumItem('五氯酚', null, 'w23025'),
    w26001: new EnumItem('苯胺', null, 'w26001'),
    w26002: new EnumItem('联苯胺', null, 'w26002'),
    w26048: new EnumItem('丙烯酰胺', null, 'w26048'),
    w99010: new EnumItem('丙烯腈', null, 'w99010'),
    w29002: new EnumItem('邻苯二甲酸二丁酯', null, 'w29002'),
    w29004: new EnumItem('邻苯二甲酸二（2—乙基己基）酯', null, 'w29004'),
    w21009: new EnumItem('水合肼', null, 'w21009'),
    w20047: new EnumItem('四乙基铅', null, 'w20047'),
    w25052: new EnumItem('吡啶', null, 'w25052'),
    w22007: new EnumItem('松节油', null, 'w22007'),
    w23036: new EnumItem('苦味酸', null, 'w23036'),
    w32003: new EnumItem('丁基黄原酸', null, 'w32003'),
    w21023: new EnumItem('活性氯', null, 'w21023'),
    w33007: new EnumItem('滴滴涕', null, 'w33007'),
    w33005: new EnumItem('林丹', null, 'w33005'),
    w99003: new EnumItem('环氧七氯', null, 'w99003'),
    w33020: new EnumItem('对硫磷', null, 'w33020'),
    w33021: new EnumItem('甲基对硫磷', null, 'w33021'),
    w33022: new EnumItem('马拉硫磷', null, 'w33022'),
    w33019: new EnumItem('乐果', null, 'w33019'),
    w33010: new EnumItem('敌敌畏', null, 'w33010'),
    w33011: new EnumItem('敌百虫', null, 'w33011'),
    w33025: new EnumItem('内吸磷', null, 'w33025'),
    w33012: new EnumItem('百菌清', null, 'w33012'),
    w33047: new EnumItem('甲萘威', null, 'w33047'),
    w33052: new EnumItem('溴氰菊酯', null, 'w33052'),
    w33029: new EnumItem('阿特拉津', null, 'w33029'),
    w25043: new EnumItem('苯并（a）芘', null, 'w25043'),
    w20136: new EnumItem('甲基汞', null, 'w20136'),
    w27001: new EnumItem('多氯联苯⑥', null, 'w27001'),
    w99004: new EnumItem('微囊藻毒素—L R', null, 'w99004'),
    w21013: new EnumItem('黄磷', null, 'w21013'),
    w20061: new EnumItem('钼', null, 'w20061'),
    w20038: new EnumItem('钴', null, 'w20038'),
    w20127: new EnumItem('铍', null, 'w20127'),
    w20023: new EnumItem('硼', null, 'w20023'),
    w20004: new EnumItem('锑', null, 'w20004'),
    w20121: new EnumItem('镍', null, 'w20121'),
    w20012: new EnumItem('钡', null, 'w20012'),
    w20101: new EnumItem('钒', null, 'w20101'),
    w20095: new EnumItem('钛', null, 'w20095'),
    w20089: new EnumItem('铊', null, 'w20089'),
    w01020: new EnumItem('总有机碳（TOC）', null, 'w01020'),
    w01022: new EnumItem('蓝绿藻', null, 'w01022'),
    w01016: new EnumItem('叶绿素a', null, 'w01016'),
    w19011: new EnumItem('藻密度', null, 'w19011'),
    w02004: new EnumItem('总大肠菌群', null, 'w02004'),
    w02005: new EnumItem('耐热大肠菌群', null, 'w02005'),
    w02006: new EnumItem('细菌总数', null, 'w02006'),
    w02007: new EnumItem('大肠埃希氏菌', null, 'w02007'),
    w01006: new EnumItem('浊度2', null, 'w01006'),
    w21006: new EnumItem('亚硝酸盐', null, 'w21006'),
    w21015: new EnumItem('（正）磷酸盐', null, 'w21015'),
    w01023: new EnumItem('综合生物毒性（发光菌）', null, 'w01023'),
    w01024: new EnumItem('综合生物毒性（鱼法）', null, 'w01024'),
    w25073: new EnumItem('对、间二甲苯', null, 'w25073'),
    w01012: new EnumItem('浊度3', null, 'w01012'),
    w01030: new EnumItem('蓝藻', null, 'w01030'),
    w01031: new EnumItem('绿藻', null, 'w01031'),
    w01032: new EnumItem('硅甲藻', null, 'w01032'),
    w01033: new EnumItem('隐藻', null, 'w01033'),
    VT:     new EnumItem('电源电压', null, 'VT'),
    COND:     new EnumItem('电导率', null, 'COND'),
    e01201:     new EnumItem('水位', null, 'e01201'),
    e01203:     new EnumItem('瞬时流量', null, 'e01203'),
    e01202:     new EnumItem('流速', null, 'e01202'),
    ...enumMixn,
};
export default EnumDivisor;
